import { render, staticRenderFns } from "./P2PTransfer.vue?vue&type=template&id=66e7e661&scoped=true"
import script from "./P2PTransfer.vue?vue&type=script&lang=js"
export * from "./P2PTransfer.vue?vue&type=script&lang=js"
import style0 from "./P2PTransfer.vue?vue&type=style&index=0&id=66e7e661&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e7e661",
  null
  
)

export default component.exports